import { HeadingSection, useStyles } from 'bold-ui'
import { Divider } from 'components/divider/Divider'
import { RastreioCancerPerguntaDbEnum } from 'graphql/types.generated'

import { DadosResponsavelConselhoSection } from '../DadosResponsavelConselhoSection'
import { MamografiaAnamneseVisualizacaoSection } from './anamnese/MamografiaAnamneseVisualizacaoSection'
import { MamografiaIndicacaoClinicaVisualizacaoSection } from './indicacao-clinica/MamografiaIndicacaoClinicaVisualizacaoSection'
import { MamografiaPerguntaField } from './model-mamografia'

export interface MamografiaVisualizacaoProps {
  questoesRespondidas: Map<RastreioCancerPerguntaDbEnum, string>
}

export function MamografiaVisualizacao(props: Readonly<MamografiaVisualizacaoProps>) {
  const { questoesRespondidas } = props
  const { classes } = useStyles(createStyles)

  return (
    <>
      <Divider style={classes.divider} />
      <HeadingSection level={3} vSpace={10} title='Requisição de exame de mamografia' />
      <MamografiaAnamneseVisualizacaoSection questoesRespondidas={questoesRespondidas} />
      <MamografiaIndicacaoClinicaVisualizacaoSection questoesRespondidas={questoesRespondidas} />
      <DadosResponsavelConselhoSection
        titulo='DADOS DO EXAME'
        dataLabel='Data de solicitação'
        data={questoesRespondidas.get(MamografiaPerguntaField.dataSolicitacao)!}
        responsavelTitulo='Responsável'
        nome={questoesRespondidas.get(MamografiaPerguntaField.nomeResponsavel)!}
        cns={questoesRespondidas.get(MamografiaPerguntaField.cns)!}
        conselho={questoesRespondidas.get(MamografiaPerguntaField.siglaNomeConselho)!}
        numero={questoesRespondidas.get(MamografiaPerguntaField.numeroConselho)!}
      />
    </>
  )
}

const createStyles = () => ({
  divider: {
    width: '100%',
  },
})
